import designs from "../services/dstore.designs";
import notification from "../services/notification";

export default {
    namespaced: true,

    state: {
        loading: false,
        designDetails: null,
        designList: [],
        merchantDesignList: [],
        errors: null,
        featureBanner: null,
        featuredBannerList: null,
        published: null,
        webDesigns: null,
        specificWebDesign: null,
        newsAndPopups: [],
        activeListType: "saved",
        modal: {
            croppa: {
                status: false,
                base64: null,
                origin: null
            }
        },
        banner_active_img: null
    },

    mutations: {
        loading(state, value) {
            state.loading = value;
        },

        setDesignDetails(state, designDetails) {
            state.designDetails = designDetails;
            state.loading = false;
        },

        designList(state, designList) {
            state.designList = designList;
            state.loading = false;
        },

        merchantList(state, details) {
            state.merchantDesignList = details.themes;
            state.loading = false;
        },

        errors(state, errors) {
            state.errors = errors;
            state.loading = false;
        },

        setErrors(state, errors) {
            state.errors = errors;
            state.loading = false;
        },

        featureBanner(state, featureBanner) {
            state.featureBanner = featureBanner;
        },

        featuredBannerList(state, featuredBannerList) {
            state.featuredBannerList = featuredBannerList;
        },

        published(state, published) {
            state.published = published;
        },

        webDesigns(state, webDesigns) {
            state.webDesigns = webDesigns;
        },

        specificWebDesign(state, specificWebDesign) {
            state.specificWebDesign = specificWebDesign;
        },

        setNewsAndPopup(state, list) {
            state.newsAndPopups = list;
        },

        setActiveListType(state, payload) {
            state.activeListType = payload;
        },
        setModal(state, param) {
            state.modal[param.type].status = param.status;

            if (param.type === "croppa") {
                state.modal[param.type].base64 = param.base64;
                state.modal[param.type].origin = param.origin;

                // if (param.status == false) {
                //     state.modal[param.origin].status = true;
                // }
            }
        },
        setActiveImage(state, index) {
            state.banner_active_img = index;
        }
    },

    getters: {
        newsAndPopups: state => state.newsAndPopups,
        loading: state => state.loading,
        activeListType: state => state.activeListType
    },

    actions: {
        async setCustomerListPublishedFalse({ commit }, list) {
            commit("customerList", { themes: list });
        },
        async setMerchantListPublishedFalse({ commit }, list) {
            commit("merchantList", { themes: list });
        },
        async getDesigns({ commit }) {
            commit("loading", true);
            try {
                let response = await designs.getDesigns();
                commit("designList", response.data.list);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async getDesignDetails({ commit }, uuid) {
            commit("loading", true);
            try {
                let response = await designs.getDesignDetails(uuid);
                commit("setDesignDetails", response.data.design);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async createDesign({ commit }, param) {
            commit("loading", true);

            try {
                let response = await designs.createDesign(param);
                // commit("getDetails", response);
                commit("loading", false);
                notification.success(response.message);
            } catch (errors) {
                commit("loading", false);
                if (errors == "Allowable saved draft is 10.") {
                    commit("errors", errors);
                    notification.error(errors);
                } else if (errors == "Allowable published is 6.") {
                    commit("errors", errors);
                    notification.error(errors);
                } else if (errors == "Allowable 10 designs only.") {
                    commit("errors", errors);
                    notification.error(errors);
                } else if (errors == "Allowable published is 1.") {
                    commit("errors", errors);
                    notification.error(errors);
                } else if (errors == "Allowable saved draft is 9.") {
                    commit("errors", errors);
                    notification.error(errors);
                } else {
                    commit("errors", errors);
                }
            }
        },
        async updateDesign({ commit }, param) {
            commit("loading", true);

            try {
                let response = await designs.updateDesign(param.uuid, param);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                commit("loading", false);
                if (errors == "Allowable saved draft is 10.") {
                    commit("errors", errors);
                    notification.error(errors);
                } else if (errors == "Allowable published is 6.") {
                    commit("errors", errors);
                    notification.error(errors);
                } else if (errors == "Allowable 10 designs only.") {
                    commit("errors", errors);
                    notification.error(errors);
                } else if (errors == "Allowable published is 1.") {
                    commit("errors", errors);
                    notification.error(errors);
                } else if (errors == "Allowable saved draft is 9.") {
                    commit("errors", errors);
                    notification.error(errors);
                } else {
                    commit("errors", errors);
                }
            }
        },
        async publishDesign({ commit }, data) {
            commit("loading", true);

            try {
                let response = await designs.publishDesign(data);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async deleteDesign({ commit }, uuid) {
            commit("loading", true);

            try {
                let response = await designs.deleteDesign(uuid);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async getMerchantDesigns({ commit }) {
            commit("loading", true);

            try {
                let response = await designs.getMerchantDesigns();
                commit("merchantList", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async getMerchantDesignDetails({ commit }, uuid) {
            commit("loading", true);
            try {
                let response = await designs.getMerchantDesignDetails(uuid);
                commit("getDetails", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async createMerchantDesign({ commit }, param) {
            commit("loading", true);

            try {
                let response = await designs.createMerchantDesign(param);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                notification.error(errors);
                commit("loading", false);
            }
        },
        async updateMerchantDesign({ commit }, param) {
            commit("loading", true);
            try {
                let response = await designs.updateMerchantDesign(
                    param.uuid,
                    param
                );
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async publishMerchantDesign({ commit }, data) {
            commit("loading", true);
            try {
                let response = await designs.publishMerchantDesign(data);
                if (data.notify) {
                    notification.success(response.message);
                }
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async deleteMerchantDesign({ commit }, uuid) {
            commit("loading", true);
            try {
                let response = await designs.deleteMerchantDesign(uuid);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async publishFeatureBanner({ commit }, param) {
            commit("loading", true);
            commit("errors", null);
            try {
                commit("loading", true);
                let response = await designs.publishFeatureBanner(param);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                commit("loading", true);
                if (errors.status == 400)
                    notification.warning(errors.errors.message);
                // else if(errors.status == 422)
                //     notification.warning("You have already reached the maximum limit of active banners. Please de-activate other existing banners.");
                else notification.warning("Oops, cannot save banner.");
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async viewFeatureBanner({ commit }, uuid) {
            commit("loading", true);
            commit("errors", null);
            try {
                let response = await designs.viewFeatureBanner(uuid);
                commit("featureBanner", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async updateFeatureBanner({ commit }, param) {
            commit("loading", true);
            commit("errors", null);
            try {
                let response = await designs.updateFeatureBanner(
                    param.uuid,
                    param
                );
                notification.success(response.message);
                commit("loading", false);
                commit("errors", null);
            } catch (errors) {
                notification.warning("Oops, cannot save banner.");
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async deleteFeatureBanner({ commit }, uuid) {
            commit("loading", true);
            try {
                let response = await designs.deleteFeatureBanner(uuid);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async getFeaturedBannerList({ commit }) {
            commit("loading", true);
            try {
                let response = await designs.getFeaturedBannerList();
                commit("featuredBannerList", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async saveWebDesign({ commit }, param) {
            commit("loading", true);
            try {
                let response = await designs.saveWebDesign(param);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Oops, cannot save design.");
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async getWebDesigns({ commit }) {
            commit("loading", true);
            try {
                let response = await designs.getWebDesigns();
                commit("webDesigns", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async deleteWebDesign({ commit }, uuid) {
            commit("loading", true);
            try {
                let response = await designs.deleteWebDesign(uuid);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async viewWebDesign({ commit }, uuid) {
            commit("loading", true);
            commit("errors", null);
            try {
                let response = await designs.viewWebDesign(uuid);
                commit("specificWebDesign", response.web_design);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async updateWebDesign({ commit }, param) {
            commit("loading", true);
            try {
                let response = await designs.updateWebDesign(param.uuid, param);
                notification.success(response.message);
                commit("loading", false);
                commit("errors", null);
            } catch (errors) {
                notification.warning("Oops, cannot save banner.");
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async publishWebDesign({ commit }, param) {
            commit("loading", true);
            try {
                let response = await designs.publishWebDesign(param);
                notification.success(response.message);
                // commit("publishedWebDesign", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        // News & Pop Up
        async getNewsPopUp({ commit }, param) {
            commit("loading", true);
            try {
                const response = await designs.getNewsPopUp(param);
                commit("setNewsAndPopup", JSON.parse(response.list));
            } catch (errors) {
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        }
    }
};
